import { defineComponent as _defineComponent } from 'vue'
import { fetchJson, HTTPMethod } from '@padlet/fetch'
import getCsrfToken from 'bits/csrf_token'
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import { availableLocales } from 'bits/locale'
import { reload } from 'bits/location'
import OzDropdownButton, {
  OzDropdownButtonColorScheme,
  OzDropdownButtonSizePreset,
} from 'library/v4/components/OzDropdownButton.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import type { PopoverAnchor } from 'types'
import { computed, ref } from 'vue'
import LocaleMenu from 'vuecomponents/LocaleMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocaleSelector',
  setup(__props) {

const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait, windowHeight } = storeToRefs(windowSizeStore)

const currentLocale = ref(hyphenatedCurrentLocale)
const isSelectorOpen = ref(false)
const menuAnchor = ref({} as Partial<PopoverAnchor>)
const localeSelector = ref<OzDropdownButton>()
const currentLocaleName = computed(
  () => availableLocales.find((locale) => locale.html === currentLocale.value)?.name || 'English (US)',
)

function updateMenuAnchor(): void {
  const el = localeSelector?.value?.$el
  if (!el) return
  menuAnchor.value = getAnchorFromElement(el, { top: -4, left: -4 })
}

function openMenu(): void {
  updateMenuAnchor()
  isSelectorOpen.value = true
}

function closeMenu(): void {
  isSelectorOpen.value = false
}

async function handleChangeLocale(lang: string): Promise<void> {
  currentLocale.value = lang
  isSelectorOpen.value = false

  await fetchJson('/session', {
    method: HTTPMethod.put,
    body: JSON.stringify({ lang }),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })

  reload()
}

// Wait for the page fully rendered before (re)calculating the menu anchor
const onPageLoad = () => {
  updateMenuAnchor()
  window.removeEventListener('load', onPageLoad)
}
window.addEventListener('load', onPageLoad)

return { __sfc: true,windowSizeStore, isSmallerThanTabletPortrait, windowHeight, currentLocale, isSelectorOpen, menuAnchor, localeSelector, currentLocaleName, updateMenuAnchor, openMenu, closeMenu, handleChangeLocale, onPageLoad, OzDropdownButton, OzDropdownButtonColorScheme, OzDropdownButtonSizePreset, LocaleMenu }
}

})